class SlideDto {
    constructor() {
        this.type = null;
        this.name = null;
        this.url = null;
        this.image = null;
    }
}

export default SlideDto;